export const services = [
    {
      title: "Web Development",
      icon: "globe",
      description: "Custom websites and web applications tailored to your business needs with modern technologies."
    },
    {
      title: "Cloud Solutions",
      icon: "cloud",
      description: "Scalable cloud infrastructure and services to power your business applications."
    },
    {
      title: "Software Development",
      icon: "laptop-code",
      description: "Custom software solutions designed to streamline your business operations."
    },
    {
      title: "App Development",
      icon: "mobile-screen",
      description: "Cross-platform mobile applications for iOS and Android with native performance."
    },
    {
      title: "Real Estate Systems",
      icon: "house",
      description: "Comprehensive property management and listing systems for real estate businesses."
    },
    {
      title: "Sports Book Platforms",
      icon: "futbol",
      description: "Secure and engaging sports betting platforms with real-time updates."
    }
  ];